import { Optional } from 'packages/types'
import { BriefLetter, BriefResume, BriefExpertDoc } from 'builder/modules/panel'

type BriefDocument = BriefLetter | BriefResume | BriefExpertDoc

export const isResumeDocument = (doc: Optional<BriefDocument>): doc is BriefResume => {
  return doc?.type === 'resume'
}

export const isCoverLetterDocument = (doc: Optional<BriefDocument>): doc is BriefLetter => {
  return doc?.type === 'cover_letter'
}

export const isExpertDocument = (doc: Optional<BriefDocument>): doc is BriefExpertDoc => {
  return doc?.type === 'tr_document'
}
